<app-header *ngIf="token"></app-header>
<app-login-header *ngIf="!token"></app-login-header>

<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class=" p-3"> <!-- Added padding for better spacing -->
        <app-industry-profile-card></app-industry-profile-card>
        <app-all-station-device-wise-industry-profile></app-all-station-device-wise-industry-profile>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
